export const getMappedValue = <T extends { name: string; value: any }, U>(field: T, data: U, mappers: Record<string, (value: any) => any>): any => {
  const mapper = mappers[field.name];
  const fieldData = data[field.name as keyof U];
  return mapper ? mapper(fieldData) : fieldData || field.value;
};
